import { render, staticRenderFns } from "./TechTab.vue?vue&type=template&id=bfdc060e&scoped=true"
import script from "./TechTab.vue?vue&type=script&lang=js"
export * from "./TechTab.vue?vue&type=script&lang=js"
import style0 from "./TechTab.vue?vue&type=style&index=0&id=bfdc060e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdc060e",
  null
  
)

export default component.exports